import AnnouncementAdminListLoader from './parts/Loaders/AnnouncementAdminListLoader';
import AnnouncementAdminTable from './parts/AnnouncementAdminTable';

function AnnouncementAdminList() {
  return (
    <AnnouncementAdminListLoader>
      <AnnouncementAdminTable />
    </AnnouncementAdminListLoader>
  );
}

export default AnnouncementAdminList;
